import api from "@/lib/api";

// Sprint 41.0 — Pre-calentamiento de IA (warm-up).
// Dispara UN único ping silencioso por sesión al endpoint de IA para abrir el túnel
// con la Universal Key y evitar el cold start (~60s) en la primera captura real.
const SESSION_FLAG = "pap_ai_warmed";

export function warmUpAI() {
  try {
    if (sessionStorage.getItem(SESSION_FLAG)) return; // ya se calentó en esta sesión
    sessionStorage.setItem(SESSION_FLAG, "1"); // marca ANTES de disparar (garantiza una sola vez)
  } catch {
    // sessionStorage no disponible: seguimos, pero sin garantía de único disparo
  }
  // Fire-and-forget: en segundo plano, sin bloquear la UI ni mostrar spinners. Errores ignorados.
  api.post("/operativa/valet/ai-parse", { modo: "warmup", warmup: true }).catch(() => {});
}
